export const EMAIL_TEMPLATE_PLACEHOLDER_LABEL_KEYS = {
    '{name}': 'email-templates.placeholders.name',
    '{product}': 'email-templates.placeholders.product',
    '{zone}': 'email-templates.placeholders.zone',
    '{auctioneer}': 'email-templates.placeholders.auctioneer',
    '{opening}': 'email-templates.placeholders.opening',
    '{closing}': 'email-templates.placeholders.closing',
    '{quantity}': 'email-templates.placeholders.quantity',
    '{finalPrice}': 'email-templates.placeholders.finalPrice',
    '{phase}': 'email-templates.placeholders.phase',
};

export const EMAIL_TEMPLATE_PLACEHOLDERS_EN = {
    '{name}': 'March 2026 ETS1 Auction',
    '{product}': 'EUA Primary Market Auction (T3PA)',
    '{zone}': 'EU',
    '{auctioneer}': 'EU',
    '{opening}': '01.03.2026 09:00',
    '{closing}': '01.03.2026 11:00',
    '{quantity}': '3,000,000',
    '{finalPrice}': '85.42 EUR',
    '{phase}': 'Finished',
};

export const EMAIL_TEMPLATE_PLACEHOLDERS_DE = {
    '{name}': 'March 2026 ETS1 Auction',
    '{product}': 'EUA Primary Market Auction (T3PA)',
    '{zone}': 'EU',
    '{auctioneer}': 'EU',
    '{opening}': '01.03.2026 09:00',
    '{closing}': '01.03.2026 11:00',
    '{quantity}': '3,000,000',
    '{finalPrice}': '85.42 EUR',
    '{phase}': 'Beendet',
};

export function applyPlaceholderExamples(text, language = 'en') {
    if (!text) {
        return text;
    }
    const placeholders = language === 'de' ? EMAIL_TEMPLATE_PLACEHOLDERS_DE : EMAIL_TEMPLATE_PLACEHOLDERS_EN;
    return Object.entries(placeholders).reduce(
        (result, [token, example]) => result.split(token).join(example),
        text,
    );
}
